exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Zgmb7_EGtJe174WafWjxf{float:left;width:100%;padding:20px;font-weight:100;color:#4a4a4a}", "", {"version":3,"sources":["/Users/mrodrigo/Documents/DEV/v2APP/src/components/organisms/Timeline/Containers/BoxText/style.css"],"names":[],"mappings":"AAAA,uBACI,WAAY,AACZ,WAAY,AACZ,aAAc,AACd,gBAAiB,AACjB,aAAe,CAClB","file":"style.css","sourcesContent":[".content {\n    float: left;\n    width: 100%;\n    padding: 20px;\n    font-weight: 100;\n    color: #4a4a4a;\n}"],"sourceRoot":""}]);

// exports
exports.locals = {
	"content": "Zgmb7_EGtJe174WafWjxf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/organisms/Timeline/Containers/BoxText/style.css
// module id = 854
// module chunks = 0 1 2 3 4 6